export default __webpack_public_path__ + "static/media/mail.2a45512c.svg";